const codeMatchesPercentage = (code) => {
    return (code === 'STATO:0000639' || code === 'TBD:0000017');
};

const codeMatchesProportion = (code) => {
    return (code === "STATO:0000607" || code === "C44256" || code === "TBD:0000185" || code === 'TBD:0000018' || code === 'STATO:0000620');
};

const codeMatchesRiskDifference = (code) => {
    return (code === 'STATO:0000424' || code === "0000424");
};


const generateSectionTextForAssertion = (comparativeEvidenceJson) => {
    let sectionText = {
        "status": "empty",
        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Evidence Resource found.]</p></div>"
    }
    if (comparativeEvidenceJson) {
        if (comparativeEvidenceJson.assertion) {
            sectionText = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + comparativeEvidenceJson.assertion + "</p></div>"
            };
        } else {
            sectionText = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No assertion provided.]</p></div>"
            }
        }
    }
    return sectionText;
};

const generateSectionTextForCertaintyOfEvidence = (comparativeEvidenceJson) => {
    let sectionText = {
        "status": "empty",
        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Evidence Resource found.]</p></div>"
    }
    if (comparativeEvidenceJson) {
        if (comparativeEvidenceJson.certainty?.length > 0) {
            sectionText = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Overall certainty rating found.]</p></div>"
            };
            for (const certainty of comparativeEvidenceJson.certainty) {
                if (certainty.type && certainty.type.coding && certainty.type.coding.length > 0 && certainty.type.coding[0].code === "Overall") {
                    if (certainty.rating && certainty.rating.coding && certainty.rating.coding.length > 0 && certainty.rating.coding[0].display) {
                        sectionText = {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certainty.rating.coding[0].display + "</p></div>"
                        };
                    }
                }
            }
        } else {
            sectionText = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No certainty rating found.]</p></div>"
            }
        }
    }
    return sectionText;
};

const generateSectionTextForEffectEstimate = (comparativeEvidenceJson) => {
    let sectionText = {
        "status": "empty",
        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Evidence Resource found.]</p></div>"
    }
    if (comparativeEvidenceJson) {
        sectionText = {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
        }
        if (comparativeEvidenceJson.statistic?.length > 0) {
            let statisticNarrativeSummary = "";
            for (const statistic of comparativeEvidenceJson.statistic) {
                let statisticTypeDisplay = '';
                let statisticValueString = '';
                let statisticValueNumber;
                let attributeEstimateDisplay = '';
                let lowValue = 'NA';
                let highValue = 'NA';
                let lowValueNumber;
                let highValueNumber;
                let isARiskDifference = false;
                if (statistic.statisticType && statistic.statisticType.coding && statistic.statisticType.coding.length > 0 && statistic.statisticType.coding[0].display) {
                    statisticTypeDisplay = statistic.statisticType.coding[0].display + ' ';
                    if (codeMatchesRiskDifference(statistic.statisticType.coding[0].code)) {
                        isARiskDifference = true;
                    }
                }
                if (statistic.quantity && statistic.quantity.value !== undefined && statistic.quantity.value !== null && !isNaN(statistic.quantity.value)) {
                    statisticValueNumber = Number(statistic.quantity.value);
                    if (statistic.quantity.unit !== undefined && statistic.quantity.unit !== "") {
                        statisticValueString = parseFloat(statisticValueNumber.toFixed(2)) + " " + statistic.quantity.unit;
                    } else if (isARiskDifference) {
                        statisticValueString = parseFloat((statisticValueNumber * 100).toFixed(2)) + "%";
                    } else {
                        statisticValueString = parseFloat(statisticValueNumber.toFixed(2)).toString();
                    }
                }
                if (statistic.attributeEstimate && statistic.attributeEstimate.length > 0) {
                    const attributeEstimate = statistic.attributeEstimate[0];
                    let attributeEstimateType = '';
                    if (attributeEstimate.type && attributeEstimate.type.coding && attributeEstimate.type.coding.length > 0 && attributeEstimate.type.coding[0].display) {
                        attributeEstimateType = '95% ' + attributeEstimate.type.coding[0].display;
                    }
                    if (attributeEstimate.range) {
                        if (attributeEstimate.range.low && attributeEstimate.range.low.value !== undefined && !isNaN(attributeEstimate.range.low.value)) {
                            lowValueNumber = Number(attributeEstimate.range.low.value);
                            if (attributeEstimate.range.low.unit !== undefined && attributeEstimate.range.low.unit !== "") {
                                lowValue = parseFloat(lowValueNumber.toFixed(2)) + " " + attributeEstimate.range.low.unit;
                            } else if (isARiskDifference) {
                                lowValue = parseFloat((lowValueNumber * 100).toFixed(2)) + "%";
                            } else {
                                lowValue = parseFloat(lowValueNumber.toFixed(2)).toString();
                            }
                        }
                        if (attributeEstimate.range.high && attributeEstimate.range.high.value !== undefined && !isNaN(attributeEstimate.range.high.value)) {
                            highValueNumber = Number(attributeEstimate.range.high.value);
                            if (attributeEstimate.range.high.unit !== undefined && attributeEstimate.range.high.unit !== "") {
                                highValue = parseFloat(highValueNumber.toFixed(2)) + " " + attributeEstimate.range.high.unit;
                            } else if (isARiskDifference) {
                                highValue = parseFloat((highValueNumber * 100).toFixed(2)) + "%";
                            } else {
                                highValue = parseFloat(highValueNumber.toFixed(2)).toString();
                            }
                        }
                    }
                    attributeEstimateDisplay = ' (' + attributeEstimateType + ' ' + lowValue + ' to ' + highValue + ')'
                }
                if (statisticNarrativeSummary) {
                    statisticNarrativeSummary += "; " + statisticTypeDisplay + statisticValueString + attributeEstimateDisplay
                } else {
                    statisticNarrativeSummary = statisticTypeDisplay + statisticValueString + attributeEstimateDisplay
                }
            }
            sectionText = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + statisticNarrativeSummary + "</p></div>"
            };
        } else {
            sectionText = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
            }
        }
    }
    return sectionText;
}

const generateSectionTextForPercentage = (evidenceJson) => {
    let sectionText = {
        "status": "empty",
        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Evidence Resource found.]</p></div>"
    }
    if (evidenceJson) {
        if (evidenceJson.statistic?.length > 0) {
            let percentage = NaN;
            for (const stat of evidenceJson.statistic) {
                if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                    codeMatchesProportion(stat.statisticType.coding[0].code)) {
                    if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                        percentage = stat.quantity.value * 100;
                        break;
                    }
                }
                if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                    codeMatchesPercentage(stat.statisticType.coding[0].code)) {
                    if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value)) {
                        percentage = stat.quantity.value;
                        break;
                    }
                }
                if (stat.statisticType && stat.statisticType.coding && stat.statisticType.coding.length > 0 &&
                    (stat.statisticType.coding[0].code === 'STATO:0000047')) {
                    if (stat.quantity && stat.quantity.value !== undefined && !isNaN(stat.quantity.value) && stat.sampleSize) {
                        let denominator = stat.sampleSize.numberAnalyzed || stat.sampleSize.knownDataCount || stat.sampleSize.numberOfParticipants || 0;
                        if (denominator > 0) {
                            percentage = (stat.quantity.value / denominator) * 100;
                            break;
                        }
                    }
                }
            }
            if (isNaN(percentage)) {
                sectionText = {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Not a proportion.]</p></div>"
                }
            } else {
                sectionText = {
                    "status": "generated",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + parseFloat(percentage.toFixed(2)) + "%</p></div>"
                }
            }
        } else {
            sectionText = {
                "status": "empty",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
            }
        }
    }
    return sectionText;
};

const generateSectionTextForSampleSize = (comparativeEvidenceJson) => {
    let sectionText = {
        "status": "empty",
        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No Evidence Resource found.]</p></div>"
    }
    if (comparativeEvidenceJson) {
        sectionText = {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No statistic found.]</p></div>"
        }
        if (comparativeEvidenceJson.statistic?.length > 0) {
            for (const statistic of comparativeEvidenceJson.statistic) {
                let resultDisplayList = [];
                if (statistic.sampleSize) {
                    if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                    }
                    if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                    }
                    if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                    }
                    if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                        resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                    }
                }
                if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                    let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                    resultDisplayList.push(abc + ' events');
                }
                if (resultDisplayList.length) {
                    sectionText = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + resultDisplayList.join(', ') + "</p></div>"
                    };
                    break;
                } else {
                    sectionText = {
                        "status": "empty",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No sample size data.]</p></div>"
                    };
                }

            }
        }
    }
    return sectionText;
}

const generateSummaryOfFindingsFromOutcomeMeasureReport = (reportJson, resourceDictionary) => {
    if (!resourceDictionary) {
        return null;
    }
    let resultsSections = reportJson.section;
    let sofJson = {
        "resourceType": "Composition",
        "meta": {
            "profile": [
                "http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-findings"
            ]
        },
        "text": {
            "status": "empty",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>"
        },
        "status": "final",
        "type": {
            "coding": [
                {
                    "system": "https://fevir.net/resources/CodeSystem/179423",
                    "code": "SummaryOfFindings",
                    "display": "SummaryOfFindings"
                }
            ],
            "text": "Summary of Findings"
        },
        "title": reportJson.title + " Summary of Findings",
        "custodian": {
            "reference": "Organization/118079",
            "type": "Organization",
            "display": "Computable Publishing LLC"
        },
        "relatesTo": [
            {
                "type": "derived-from",
                "targetReference": {
                    "reference": "Composition/" + reportJson.id,
                    "type": "Composition",
                    "display": reportJson.title
                }
            }
        ],
        "section": [
            {
                "title": "Column Headers",
                "code": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "column-headers",
                            "display": "Column Headers"
                        }
                    ]
                },
                "section": [
                    {
                        "title": "Outcome Measure",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "outcome-measure",
                                    "display": "Outcome Measure"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Outcome</p></div>"
                        }
                    },
                    {
                        "title": "Sample Size",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "sample-size",
                                    "display": "Sample Size"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Sample Size</p></div>"
                        }
                    },
                    {
                        "title": "Result Without Treatment",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-comparator-alone",
                                    "display": "Result with comparator alone"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result Without Treatment</p></div>"
                        }
                    },
                    {
                        "title": "Result With Treatment--Observed",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-alone",
                                    "display": "Result with intervention alone"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Observed)</p></div>"
                        }
                    },
                    {
                        "title": "Result With Treatment--Derived",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-alone-calculated",
                                    "display": "Result with intervention alone (calculated)"
                                }
                            ],
                            "text": "result with intervention with calculated value derived from the control group and effect estimate"
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Result With Treatment (Calculated)</p></div>"
                        }
                    },
                    {
                        "title": "Effect Estimate",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-vs-comparator",
                                    "display": "Result with intervention vs. comparator"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Effect Estimate</p></div>"
                        }
                    },
                    {
                        "title": "Certainty of Evidence",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "certainty-of-evidence",
                                    "display": "Certainty of Evidence"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>Certainty of Evidence</p></div>"
                        }
                    },
                    {
                        "title": "Assertion",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "assertion",
                                    "display": "Assertion"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>What this means</p></div>"
                        }
                    }
                ]
            },
            {
                "title": "Summary of Findings",
                "code": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "summary-of-findings",
                            "display": "Summary of Findings"
                        }
                    ]
                },
                "text": {
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>"
                },
                "section": []
            }
        ]
    }

    for (const results of resultsSections) {
        if (results.code?.coding?.[0]?.code === "results") {
            let comparativeEvidenceReference = results.entry?.[2] || { "display": "No ComparativeEvidence Resource identified." };
            let comparativeEvidenceJson;
            if (comparativeEvidenceReference) {
                let comparativeEvidenceId = comparativeEvidenceReference.reference?.split("/")[1];
                if (comparativeEvidenceId) {
                    comparativeEvidenceJson = resourceDictionary[comparativeEvidenceId].resourceJson;
                }
            }
            let controlEvidenceReference = results.entry?.[1] || { "display": "No ComparatorOnlyEvidence Resource identified." };
            let controlEvidenceJson;
            if (controlEvidenceReference) {
                let controlEvidenceId = controlEvidenceReference.reference?.split("/")[1];
                if (controlEvidenceId) {
                    controlEvidenceJson = resourceDictionary[controlEvidenceId].resourceJson;
                }
            }
            let interventionEvidenceReference = results.entry?.[0] || { "display": "No InterventionOnlyEvidence Resource identified." };
            let interventionEvidenceJson;
            if (interventionEvidenceReference) {
                let interventionEvidenceId = interventionEvidenceReference.reference?.split("/")[1];
                if (interventionEvidenceId) {
                    interventionEvidenceJson = resourceDictionary[interventionEvidenceId].resourceJson;
                }
            }
            let sofSection = {
                "title": results.title || results.focus.display,
                "code": {
                    "coding": [
                        {
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "code": "summary-of-findings-entry-for-a-single-outcome",
                            "display": "Summary of findings entry for a single outcome"
                        }
                    ]
                },
                "focus": results.focus,
                "section": [
                    {
                        "title": "Outcome Measure",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "outcome-measure",
                                    "display": "Outcome Measure"
                                }
                            ]
                        },
                        "text": {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + (results.title.replace("Results for ", "") || results.focus.display) + "</p></div>"
                        },
                        "entry": [results.focus]
                    },
                    {
                        "title": "Sample Size",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "sample-size",
                                    "display": "Sample Size"
                                }
                            ]
                        },
                        "text": generateSectionTextForSampleSize(comparativeEvidenceJson),
                        "entry": [comparativeEvidenceReference]
                    },
                    {
                        "title": "Result Without Treatment",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-comparator-alone",
                                    "display": "Result with comparator alone"
                                }
                            ]
                        },
                        "text": generateSectionTextForPercentage(controlEvidenceJson),
                        "entry": [controlEvidenceReference]
                    },
                    {
                        "title": "Result With Treatment--Observed",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-alone",
                                    "display": "Result with intervention alone"
                                }
                            ]
                        },
                        "text": generateSectionTextForPercentage(interventionEvidenceJson),
                        "entry": [interventionEvidenceReference]
                    },
                    {
                        "title": "Result With Treatment--Derived",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-alone-calculated",
                                    "display": "Result with intervention alone (calculated)"
                                }
                            ],
                            "text": "result with intervention with calculated value derived from the control group and effect estimate"
                        },
                        "text": {
                            "status": "empty",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>"
                        }
                    },
                    {
                        "title": "Effect Estimate",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "result-with-intervention-vs-comparator",
                                    "display": "Result with intervention vs. comparator"
                                }
                            ]
                        },
                        "text": generateSectionTextForEffectEstimate(comparativeEvidenceJson),
                        "entry": [comparativeEvidenceReference]
                    },
                    {
                        "title": "Certainty of Evidence",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "certainty-of-evidence",
                                    "display": "Certainty of Evidence"
                                }
                            ]
                        },
                        "text": generateSectionTextForCertaintyOfEvidence(comparativeEvidenceJson),
                        "entry": [comparativeEvidenceReference]
                    },
                    {
                        "title": "Assertion",
                        "code": {
                            "coding": [
                                {
                                    "system": "https://fevir.net/resources/CodeSystem/179423",
                                    "code": "assertion",
                                    "display": "Assertion"
                                }
                            ]
                        },
                        "text": generateSectionTextForAssertion(comparativeEvidenceJson),
                        "entry": [comparativeEvidenceReference]
                    }
                ]
            };
            sofJson.section[1].section.push(sofSection);
        }
    }
    return sofJson;
};


export default generateSummaryOfFindingsFromOutcomeMeasureReport;